import { useState } from "react";
import Icon from "../Icon/Icon";
import Input, { InputProps } from "./Input";

export interface PasswordInputProps extends Omit<InputProps, "type"> {
  iconLeft?: boolean;
}

const PasswordInput = ({ disabled, iconLeft, ...rest }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    if (disabled) {
      return;
    }

    setShowPassword((prev) => !prev);
  };

  return (
    <Input
      {...rest}
      disabled={disabled}
      type={showPassword ? "text" : "password"}
      iconLeftName={iconLeft ? "lock-closed" : undefined}
      iconRight
      icon={
        <Icon
          name={showPassword ? "eye-off" : "eye"}
          color={
            disabled
              ? "content.neutral.base.disable"
              : "content.neutral.base.subtle"
          }
          onClick={handleShowPassword}
          cursor="pointer"
        />
      }
    />
  );
};

export default PasswordInput;
